module.exports = __webpack_public_path__ + "media/images/logo-a90875194c69438d1277cc3bd6df0cff.png";